import { render, staticRenderFns } from "./EditMainProduct.vue?vue&type=template&id=cab5c608&"
import script from "./EditMainProduct.vue?vue&type=script&lang=js&"
export * from "./EditMainProduct.vue?vue&type=script&lang=js&"
import style0 from "./EditMainProduct.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports